/* Registers /service-worker.js in production only.
 * Localhost dev keeps live-reload working (no SW).
 *
 * Auto-update strategy — so users never get stuck on a stale build:
 *  1. nginx serves service-worker.js with no-cache, and we register with
 *     updateViaCache:'none', so the browser always re-fetches the SW script.
 *  2. We poll registration.update() on focus and every 60s, so a fresh deploy
 *     is noticed within seconds without a manual refresh.
 *  3. Each deploy stamps a new BUILD_ID into the SW (scripts/stamp-sw.js); the
 *     new SW skipWaiting()s + claims clients, firing 'controllerchange', and we
 *     reload once so the freshly-deployed JS/CSS runs automatically.
 *  We do NOT reload on the very first install (no previous controller), to
 *  avoid an unnecessary refresh on a user's first visit. */
export function register() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    // Only auto-reload when an EXISTING controller is replaced by a new SW —
    // i.e. a real update, not the first-ever install.
    const hadController = !!navigator.serviceWorker.controller;
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing || !hadController) return;
      refreshing = true;
      window.location.reload();
    });

    // NOTE: we register with a ?v query, not the bare path. The bare
    // /service-worker.js was cached by Cloudflare's edge for a year with an old
    // (immutable) header, freezing everyone on a stale worker. Cloudflare keys
    // its cache by full URL, so a fresh query is a cache MISS -> fetched from
    // origin (which now sends no-store) -> never edge-cached again. Bump this
    // token only if the SW ever gets stuck behind a CDN cache once more.
    navigator.serviceWorker
      .register('/service-worker.js?v=2', { updateViaCache: 'none' })
      .then((registration) => {
        const checkForUpdate = () => registration.update().catch(() => {});
        // Check whenever the tab regains focus and on a light interval.
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') checkForUpdate();
        });
        setInterval(checkForUpdate, 60 * 1000);
      })
      .catch((err) => console.warn('SW registration failed:', err));
  });
}
